<div
  class="department-wrapper"
  [class.disabled-dnd]="haveAnyAccordionOpen"
  [class.prevent-select]="mouseDownStartDepartment"
  (mouseover)="onMouseOverAccordionDepartment($event)"
>
  <div
    *ngIf="mouseDownStartDepartment && showFirstBlockDepartment"
    class="droppable-area-out-department"
    (mouseup)="onMouseUpFirstDepartment($event)"
  ></div>
  <div
    id="{{ 'department' + category._id }}"
    class="department-item"
    [class.disable-events]="mouseDownStartDepartment"
    [class.hidden]="mouseDownStartDepartment?.itemIndex === i"
    [class.highlight]="isMouseOverDepartment === i"
    *ngFor="let category of categories; index as i"
    (mouseover)="onMouseOverDepartment($event, category, i)"
    (mouseup)="onMouseUpDepartment($event, category, i)"
  >
    <svg
      class="cursor-move-accordion"
      *ngIf="!mouseDownStartDepartment && !haveAnyAccordionOpen"
      (mousedown)="
        onMouseDownStartDepartment(
          $event,
          category,
          i,
          'accordion_' + category._id,
          category._id
        )
      "
      width="8"
      height="17"
      viewBox="0 0 8 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.20834 9.93344L4.23133 16" stroke="#31388d" />
      <path d="M7.20835 9.93344L4.18536 16" stroke="#31388d" />
      <path d="M7.20834 7.06654L4.18536 0.999992" stroke="#31388d" />
      <path d="M1.20837 7.06654L4.23135 0.999992" stroke="#31388d" />
    </svg>
    <div class="accordion" id="{{ 'accordion_' + category._id }}">
      <div class="accordion-title">
        <div
          class="click-area"
          tabindex="0"
          role="button"
          enterPress="toggleAccordion(i)"
          (keydown.enter)="toggleAccordion(i)"
          (click)="toggleAccordion(i)"
        >
          <div class="title">
            {{ category.department | translate }}&nbsp;
            <span *ngIf="renameId !== category._id">{{ category.name }}</span>
            <span *ngIf="renameId === category._id">
              <input
                focusSelect
                [(ngModel)]="newName"
                (keydown.enter)="onSaveDepartmentName(category, $event)"
                (keydown.escape)="onCancelRename(category._id)"
                (focusout)="onCancelRename(category._id)"
                (click)="$event.stopPropagation()"
              />
            </span>
          </div>
          <div class="actual-subtotal">
            {{ companyBaseCurrencySymbol }}
            {{ category.actual ?? 0 | number : '.0-0' }}
          </div>
          <div class="estimated-subtotal">
            {{ companyBaseCurrencySymbol }}
            {{ category.estimate ?? 0 | number : '.0-0' }}
          </div>
        </div> 
        <div class="comment" [class.no-comments]="!category.hasComment" id="{{ 'category-' + category._id }}">
          <img
              src="assets/comment_false.svg"
              *ngIf="!category.hasComment"
            tabindex="0"
            role="button"
            enterPress="openCommentModal('category-comments-' + category._id, category)"
            (keydown.enter)="
              openCommentModal('category-comments-' + category._id, category)
            "
            (click)="
              openCommentModal('category-comments-' + category._id, category)
            "
          />
          <img
          src="assets/comment_true.svg"
          *ngIf="category.hasComment"
          tabindex="0"
          role="button"
          enterPress="openCommentModal('category-comments-' + category._id, category)"
          (keydown.enter)="
            openCommentModal('category-comments-' + category._id, category)
          "
          (click)="
            openCommentModal('category-comments-' + category._id, category)
          "
        />


          <ops-comment-popup
          
            id="{{ 'category-comments-' + category._id }}"
            parentId="{{ 'category-' + category._id }}"
            [comments]="category.comments"
            (saveComment)="onSaveCategoryComment($event, category)"
            (deleteComment)="onDeleteCategoryComment($event, category)"
            class="comment-window"
          ></ops-comment-popup>
        </div>
        <div
          class="kebab-menu"
          id="{{ 'category' + category._id }}"
          tabindex="0"
          role="button"
          [opsActionMenu]="'category-action-' + category._id"
          [optionsFactory]="getCategoryActionMenuOptions.bind(this)"
          (itemSelected)="onCategoryActionSelected(category._id, $event)"
        >
          <img src="assets/kebab-menu-purple.svg" />
        </div>
      </div>

      <div class="item-container" *ngIf="category.open">
        <div class="header-row">
          <div
            class="checkbox"
            tabindex="0"
            role="button"
            enterPress="toggleSelectAll()"
            (keydown.enter)="toggleSelectAll()"
            (click)="toggleSelectAll()"
          >
            <img src="assets/check-box.svg" *ngIf="selectAllFlag" />
          </div>
          <div class="name header clickable">
            <img
              src="assets/arrow-order-none-purple.svg"
              *ngIf="sortBy.field !== 'name'"
            />
            <img
              [src]="
                sortBy.ascending
                  ? 'assets/arrow-order-up-purple.svg'
                  : 'assets/arrow-order-down-purple.svg'
              "
              *ngIf="sortBy.field === 'name'"
            />
            <div
              tabindex="0"
              role="button"
              enterPress="onToggleOrderBy('name', category._id, $event)"
              (keydown.enter)="onToggleOrderBy('name', category._id, $event)"
              (click)="onToggleOrderBy('name', category._id, $event)"
            >
              {{ 'productionCost.costAccordion.vendorName' | translate }}
            </div>
          </div>
          <div class="description header clickable">
            <img
              src="assets/arrow-order-none-purple.svg"
              *ngIf="sortBy.field !== 'description'"
            />
            <img
              [src]="
                sortBy.ascending
                  ? 'assets/arrow-order-up-purple.svg'
                  : 'assets/arrow-order-down-purple.svg'
              "
              *ngIf="sortBy.field === 'description'"
            />
            <div
              tabindex="0"
              role="button"
              enterPress="onToggleOrderBy('description', category._id, $event)"
              (keydown.enter)="
                onToggleOrderBy('description', category._id, $event)
              "
              (click)="onToggleOrderBy('description', category._id, $event)"
            >
              {{ 'productionCost.costAccordion.description' | translate }}
            </div>
          </div>
          <div class="bill-date header clickable">
            <img
              src="assets/arrow-order-none-purple.svg"
              *ngIf="sortBy.field !== 'dateOfBill'"
            />
            <img
              [src]="
                sortBy.ascending
                  ? 'assets/arrow-order-up-purple.svg'
                  : 'assets/arrow-order-down-purple.svg'
              "
              *ngIf="sortBy.field === 'dateOfBill'"
            />
            <div
              tabindex="0"
              role="button"
              enterPress="onToggleOrderBy('dateOfBill', category._id, $event)"
              (keydown.enter)="
                onToggleOrderBy('dateOfBill', category._id, $event)
              "
              (click)="onToggleOrderBy('dateOfBill', category._id, $event)"
            >
              {{ 'productionCost.costAccordion.dateOfBill' | translate }}
            </div>
          </div>
          <div class="payment-date header clickable">
            <img
              src="assets/arrow-order-none-purple.svg"
              *ngIf="sortBy.field !== 'paymentDate'"
            />
            <img
              [src]="
                sortBy.ascending
                  ? 'assets/arrow-order-up-purple.svg'
                  : 'assets/arrow-order-down-purple.svg'
              "
              *ngIf="sortBy.field === 'paymentDate'"
            />
            <div
              tabindex="0"
              role="button"
              enterPress="onToggleOrderBy('paymentDate', category._id, $event)"
              (keydown.enter)="
                onToggleOrderBy('paymentDate', category._id, $event)
              "
              (click)="onToggleOrderBy('paymentDate', category._id, $event)"
            >
              {{ 'productionCost.costAccordion.paymentDate' | translate }}
            </div>
          </div>
          <div class="actual header clickable">
            <img
              src="assets/arrow-order-none-purple.svg"
              *ngIf="sortBy.field !== 'total'"
            />
            <img
              [src]="
                sortBy.ascending
                  ? 'assets/arrow-order-up-purple.svg'
                  : 'assets/arrow-order-down-purple.svg'
              "
              *ngIf="sortBy.field === 'total'"
            />
            <div
              tabindex="0"
              role="button"
              enterPress="onToggleOrderBy('total', category._id, $event)"
              (keydown.enter)="onToggleOrderBy('total', category._id, $event)"
              (click)="onToggleOrderBy('total', category._id, $event)"
            >
              {{ 'productionCost.costAccordion.costInclTax' | translate }}
            </div>
          </div>
          <div class="estimated header">
            {{ 'productionCost.costAccordion.estimatedBudget' | translate }}
          </div>
        </div>
        <hr />
        <div
          class="accordion-wrapper"
          [class.disabled-dnd]="selectedItems || selectAllFlag"
          [class.prevent-select]="mouseDownStart"
          [class.disable-events]="
            mouseDownStart && categoryDDId !== category._id
          "
          (mouseover)="onMouseOverAccordion($event)"
        >
          <div
            *ngIf="
              mouseDownStart && showFirstBlock && categoryDDId === category._id
            "
            class="droppable-area-out"
            (mouseup)="onMouseUpFirst($event)"
          ></div>

          <div
            class="accordion-item"
            *ngFor="
              let item of category.items;
              index as itemIndex;
              last as isLast
            "
            (mouseover)="onMouseOver($event, item, itemIndex)"
            (mouseup)="onMouseUp($event, item, itemIndex)"
            [class.highlight]="isMouseOver === itemIndex"
            [class.hidden]="mouseDownStart?.itemIndex === itemIndex"
            id="{{ 'acitem_' + item._id }}"
          >
            <svg
              *ngIf="!mouseDownStart && !selectedItems && !selectAllFlag"
              (mousedown)="
                onMouseDownStart(
                  $event,
                  item,
                  itemIndex,
                  'acitem_' + item._id,
                  category._id
                )
              "
              class="cursor-move"
              width="8"
              height="17"
              viewBox="0 0 8 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1.20834 9.93344L4.23133 16" stroke="#31388d" />
              <path d="M7.20835 9.93344L4.18536 16" stroke="#31388d" />
              <path d="M7.20834 7.06654L4.18536 0.999992" stroke="#31388d" />
              <path d="M1.20837 7.06654L4.23135 0.999992" stroke="#31388d" />
            </svg>
            <!-- {{item.orderNumber}} -->
            <ops-cost-accordion-item
              [item]="item"
              [companyId]="companyId"
              [selectedItemsCount]="selectedItems"
              [saveFlag]="saveFlag"
              [cancelFlag]="cancelFlag"
              [selectAllFlag]="selectAllFlag"
              [positions]="category.positions"
              [positionInput]="positionInput"
              [nameInput]="nameInput"
              [paidByInput]="paidByInput"
              [paymentMethodInput]="paymentMethodInput"
              [paymentDateInput]="paymentDateInput"
              [daysInput]="daysInput"
              [unitsInput]="unitsInput"
              [unitCostInput]="unitCostInput"
              [taxPercentageInput]="taxInput"
              [costTypeInput]="costTypeInput"
              [costStatusInput]="costStatusInput"
              [dateOfBillInput]="dateOfBillInput"
              [assignToInput]="assignToInput"
              [accountingCategoryInput]="accountingCategoryInput"
              [hasReminderInput]="hasReminderInput"
              [itemGroupTitle]="category.department + ' ' + category.name"
              (itemToggled)="onItemToggled($event)"
              (recalculateTotal)="onRecalculate($event)"
              (itemDeleted)="onItemDeleted($event)"
              (duplicateItem)="onDuplicateItem($event)"
              (moveItem)="onMoveItem($event)"
              (addNewPaidByOption)="onAddNewPaidByOption($event)"
              [refreshTrigger]="refreshTrigger"
              [class.lastItem]="isLast"
            >
            </ops-cost-accordion-item>
            <div class="droppable-area"></div>
          </div>
        </div>

        <div class="add-cost" *ngIf="selectedItems < 1">
          <div
            class="button"
            tabindex="0"
            role="button"
            enterPress="onAddNewCost(category)"
            (keydown.enter)="onAddNewCost(category)"
            (click)="onAddNewCost(category)"
          >
            {{ 'productionCost.costAccordion.addNewCost' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="droppable-area-department"></div>
  </div>
</div>
<!-- <ops-add-cost
  style="display: none"
  id="add-cost-modal"
  [projectId]="projectId"
  [department]="addCostDepartmentObject"
  (costAdded)="onCostAdded($event)"
></ops-add-cost> -->

<!-- Action Menus Container -->
<div class="action-menus-container">
  <ops-action-menu
    *ngFor="let category of categories"
    [menuId]="'category-action-' + category._id"
    (itemSelected)="onCategoryActionSelected(category._id, $event)"
  ></ops-action-menu>
</div>

<!-- Move Cost Item Modal -->
<ops-move-cost-item-to-different-department
  *ngIf="showMoveModal"
  [costItem]="selectedCostItem"
  [departments]="availableDepartments"
  [loading]="moveLoading"
  [disabled]="false"
  (moveItem)="onMoveItemConfirmed($event)"
  (cancel)="onMoveItemCanceled()"
></ops-move-cost-item-to-different-department>
